export class NotificacionDto{
  mensaje!:string
  cantidad!: number
}
